import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { CloseRounded, Unsubscribe } from '@mui/icons-material'
import { disableUser } from '../../../../../../redux/actions/users'
import { CancelButton, SaveButton } from '../../../../../shared/components/inputs'
import { useTranslation } from 'react-i18next'
import { StyledDialog } from '../../../../../shared/styles/StyledDialog'

type UnsubscribeUserProps = {
  authUser: any
  userProfileSelected: any
}

function DisableUser({ authUser, userProfileSelected }: UnsubscribeUserProps) {
  const { t } = useTranslation(['global'])
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleClickUnsubscribe = () => {
    setOpen(!open)
  }

  const handleSubmitUnsubscribe = () => {
    dispatch(disableUser())
    setOpen(!open)
  }

  return (
    <>
      {authUser.id === userProfileSelected.id && (
        <Grid>
          <Button
            onClick={handleClickUnsubscribe}
            size="medium"
            variant="outlined"
            color="primary"
            startIcon={<Unsubscribe />}
          >
            {t('admin.people.unsubscribe')}
          </Button>
        </Grid>
      )}

      <StyledDialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">{t('admin.people.unsubscribe')}</Typography>
            <Button onClick={() => setOpen(false)} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>
        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid xs={12}>
              <Typography>{t('admin.people.unsubscribe-user-text')}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={() => setOpen(false)} variant="contained" color="secondary">
            {t('cancel')}
          </CancelButton>
          <SaveButton id="btn-handlelogin" endIcon={<Unsubscribe />} onClick={() => handleSubmitUnsubscribe()}>
            {t('allow')}
          </SaveButton>
        </DialogActions>
      </StyledDialog>
    </>
  )
}

export default DisableUser
